import { colorPrimitives } from '../primitives/colors';
import { colorScale } from './color-scale';

/**
 * Status colors carry a fixed meaning (low, registered, complete). A branding provider recolors
 * `colors.brand` through `--ks-colors-brand-*` variables, so a status color must never reference
 * a brand token. These hold the literal hex values the status UI showed before branding existed.
 */
const statusColors = {
  low: { value: colorPrimitives.primary[400] },
  registered: { value: colorPrimitives.primary[300] },
  complete: { value: colorPrimitives.primary[500] },
  completeBg: { value: colorPrimitives.primary[50] },
  successFg: { value: colorPrimitives.primary[800] },
};

/** Chakra color tokens — derived from {@link colorPrimitives}. */
export const colors = {
  status: statusColors,
  transparent: { value: 'transparent' },
  current: { value: 'currentColor' },
  black: { value: colorPrimitives.neutral[500] },
  white: { value: colorPrimitives.neutral[0] },
  neutral: colorScale(colorPrimitives.neutral),
  brand: colorScale(colorPrimitives.primary),
  neonGreen: colorScale(colorPrimitives.accent),
  purple: colorScale(colorPrimitives.secondary),
  secondary: colorScale(colorPrimitives.secondary),
  red: colorScale(colorPrimitives.red),
  orange: colorScale(colorPrimitives.orange),
  green: colorScale(colorPrimitives.green),
  blue: colorScale(colorPrimitives.blue),
};
